import { createDeferred } from "common/utils/deferred";

export interface PropLibraryFileStorageHelper {
  getFileStorageBaseURL(): Promise<string | null>;
}

const deferred = createDeferred<PropLibraryFileStorageHelper>();

export const propLibraryFileStorageHelper = deferred.promise;

export function setPropLibraryFileStorageHelper(helper: PropLibraryFileStorageHelper) {
  deferred.resolve(helper);
}
